import * as yup from 'yup';
import { MAX_FILE_SIZE, FILE_TOO_LARGE_PATH, SUPPORTED_FORMATS, FILE_UNSUPPORTED_FORMAT_PATH } from '../../errorMessages';

export const yupObjectFiles = {
    extraFile4: yup.mixed()
        .when("[isRentApp]", ([isRentApp]: number[], schema) => {

            if (isRentApp === 0) {
                return schema.notRequired().nullable();
            }

            return (
                schema
                    .required()
                    .test(
                        "FILE_SIZE",
                        FILE_TOO_LARGE_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && value.size <= MAX_FILE_SIZE)
                        }
                    )
                    .test(
                        "FILE_FORMAT",
                        FILE_UNSUPPORTED_FORMAT_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && SUPPORTED_FORMATS.includes(value?.contentType))
                        }
                    )
            );
        }),
    extraFile5: yup.mixed()
        .when("[isRentApp]", ([isRentApp]: number[], schema) => {

            if (isRentApp === 0) {
                return schema.notRequired().nullable();
            }

            return (
                schema
                    .required()
                    .test(
                        "FILE_SIZE",
                        FILE_TOO_LARGE_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && value.size <= MAX_FILE_SIZE)
                        }
                    )
                    .test(
                        "FILE_FORMAT",
                        FILE_UNSUPPORTED_FORMAT_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && SUPPORTED_FORMATS.includes(value?.contentType))
                        }
                    )
            );
        }),
    extraFile3: yup.mixed()
        .when("[hasBusiness]", ([hasBusiness]: number[], schema) => {

            if (hasBusiness === 0) {
                return schema.notRequired().nullable();
            }

            return (
                schema
                    .required()
                    .test(
                        "FILE_SIZE",
                        FILE_TOO_LARGE_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && value.size <= MAX_FILE_SIZE)
                        }
                    )
                    .test(
                        "FILE_FORMAT",
                        FILE_UNSUPPORTED_FORMAT_PATH,
                        (value) => {
                            //@ts-ignore
                            return !value || (value && SUPPORTED_FORMATS.includes(value?.contentType))
                        }
                    )
            );
        }),
}
